import { makeStyles, css } from '@conexasaude/conexa-hero'

const useStyles = makeStyles({
  dataWrapper: ({ spacing }) => css`
    padding-top: ${spacing.sm};

    > div {
      margin-top: ${spacing.xs};
    }
  `,

  textColor: ({ colors }) => css`
    color: ${colors.brand.primary[500]};
  `,

  infoWrapper: ({ spacing }) => css`
    display: flex;
    gap: ${spacing.sm};
    margin-top: ${spacing.xs};
  `,

  professionalWrapper: ({ spacing }) => css`
    display: grid;
    grid-template-columns: 50px auto;
    gap: ${spacing.sm};
    margin-bottom: ${spacing.sm};

    p {
      margin-bottom: 2px;
    }
  `,

  detailsWrapper: css`
    display: flex;
    gap: 4px;
    align-items: center;
  `,

  detailsInput: ({ spacing }) => css`
    display: flex;
    gap: ${spacing.xs};
    margin: ${spacing.xs} 0 ${spacing.sm} 0;
  `,

  titleWrapper: ({ spacing }) => css`
    margin: ${spacing.sm} 0 ${spacing.xs} 0;
  `,

  alertWrapper: ({ spacing }) => css`
    margin-bottom: ${spacing.sm};
  `,

  footer: ({ spacing }) => css`
    margin: ${spacing.sm} 0;
  `,
})

export default useStyles
